import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type overviewPermissionType = 'overview_view';

export const overviewPermissionMatrix: IPermissionMatrix<overviewPermissionType> = {
  overview_view: [UserRole.user]
};
